import React from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap } from 'react-icons/fa';

const educationData = [
  {
    school: 'Conestoga College',
    degree: 'Post Graduation Certificate - Web Development',
    location: 'Kitchener, ON',
    date: 'Apr 2025',
    gpa: '3.42/4.00',
    coursework: 'Full Stack, Responsive Design, JavaScript'
  },
  {
    school: 'Silver Oak University',
    degree: 'Bachelor of Engineering - Computer Engineering',
    location: 'Gujarat, IN',
    date: 'May 2023',
    gpa: '3.4/4.00',
    coursework: 'Full Stack, Database Management'
  }
];

const Education = () => {
  return (
    <section id="education" className="py-20 bg-gray-900">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
          Education
        </h2>
        <div className="space-y-8">
          {educationData.map((edu, index) => (
            <motion.div
              key={edu.school}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="relative bg-gradient-to-br from-gray-800 to-gray-700 border border-gray-600 p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all"
            >
              <div className="absolute -top-6 left-6 bg-blue-500 p-2 rounded-full shadow-lg">
                <FaGraduationCap className="text-white text-xl" />
              </div>
              <div className="pl-12">
                <h3 className="text-2xl font-bold text-blue-400">{edu.school}</h3>
                <p className="text-lg text-gray-200">{edu.degree}</p>
                <p className="text-sm text-gray-400 mb-2">
                  {edu.location} | {edu.date} | GPA: {edu.gpa}
                </p>
                <p className="text-gray-300">
                  <span className="font-semibold">Relevant Coursework:</span> {edu.coursework}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
